import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoSalessGetRes } from "./abst/DtoSalessGetRes";

export class DtoSalessGetResImple extends DtoSalessGetRes {
  public pager = new DtoApiPager();
}
